import { useState } from "react";
import { WidgetEmptyAction, type Omittable } from "@salestrak/ui";
import type { CustomFieldDef } from "#app/components/issue-view/issue-view-types";
import { SummaryAddCustomFieldsPicker } from "./add-custom-fields-picker";

/**
 * The Custom fields section while the entity has no fields: one "Add fields"
 * action the card lifts into its header in the title's place, opening the
 * shared add-fields picker directly (the picker carries its own Create-field
 * door, so no menu stands between the row and the fields). The module renders
 * this INSTEAD of the field table — never beside it — so the header's plus menu
 * and this row are never both on screen.
 */
export function SummaryCustomFieldsEmptyAction({
  fieldIds,
  customFields,
  onUpdateValue,
  locationName,
}: Omittable<{
  fieldIds: string[];
  customFields?: CustomFieldDef[];
  onUpdateValue?: (data: { customFieldId: string; value: unknown }) => void;
  locationName?: string;
}>) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <WidgetEmptyAction label="Add fields" onClick={() => setOpen(true)} />
      <SummaryAddCustomFieldsPicker
        open={open}
        onOpenChange={setOpen}
        fieldIds={fieldIds}
        customFields={customFields}
        onUpdateValue={onUpdateValue}
        locationName={locationName}
      />
    </>
  );
}
